import { useState, type ReactNode } from 'react'
import { SelectedFeederContext } from './selectedFeederContext.ts'

/**
 * Holds the cross-view "selected feeder" so the Map and the Engineering
 * dashboard share one selection: click a feeder on the map and it is already
 * selected when you open Engineering, and vice versa. Mounted above the routes
 * (see App.tsx) so the selection survives navigation between pages.
 */
export function SelectedFeederProvider({ children }: { children: ReactNode }) {
  const [selectedFeederId, setSelectedFeederId] = useState<number | null>(null)
  return (
    <SelectedFeederContext.Provider value={{ selectedFeederId, setSelectedFeederId }}>
      {children}
    </SelectedFeederContext.Provider>
  )
}
